module.exports = __webpack_public_path__ + "img/rating_helmet_dark.3fc11fb6.svg";